import React from 'react';
import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined';
import { Button, Stack } from '@mui/material';
import FileUploader from '@/operator/components/general/input/FileUploader';
import { Invitation } from '@/operator/graphql/types/Invitation';
import { convertCsvFileToInvitationList } from '../../utils/convertCsvFileToInvitationList';

interface UploadCsvFileProps {
    setInvitationList: React.Dispatch<React.SetStateAction<Invitation[]>>;
    csvFile: File;
    setCsvFile: React.Dispatch<React.SetStateAction<File>>;
}

const UploadCsvFile = ({
    setInvitationList,
    csvFile,
    setCsvFile,
}: UploadCsvFileProps) => {
    const fileReader = new FileReader();

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newFiles = event.target.files;
        if (!newFiles) {
            return;
        }

        setCsvFile(newFiles[0]);
    };

    const onLoadCsvFile = (event: ProgressEvent<FileReader>) => {
        const text = event.target.result;
        const invitationList = convertCsvFileToInvitationList(text);
        setInvitationList(invitationList);
    };

    const handleOnSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        if (csvFile) {
            fileReader.onload = function (event) {
                onLoadCsvFile(event);
            };

            fileReader.readAsText(csvFile);
        }
    };

    return (
        <Stack
            spacing={2}
            direction={'row'}
            sx={{
                justifyContent: "center",
                alignItems: "center",
            }}>
            <FileUploader
                label="Upload a file"
                subLabel="CSV only"
                accept=".csv"
                onChange={handleOnChange}
                containerStyle={{
                    backgroundColor: 'rgb(247, 246, 255, 1)',
                    marginBottom: '25px',
                }}
            />
            <Button
                variant="contained"
                startIcon={<CloudUploadOutlined />}
                disabled={!csvFile}
                onClick={handleOnSubmit}
            >
                Upload
            </Button>
        </Stack >
    );
};

export default UploadCsvFile;
